export const CREDIT_STEP1 = 'CREDIT_STEP1';
export const CREDIT_STEP2 = 'CREDIT_STEP2';
export const CREDIT_STEP3 = 'CREDIT_STEP3';
export const CREDIT_STEP4 = 'CREDIT_STEP4';
export const CREDIT_STEP5 = 'CREDIT_STEP5';



// WEBPACK FOOTER //
// ./src/app/pages/credit/CreditConstants.js